import { ExternalLinkIcon } from 'lucide-react'
import { Menu } from '../../../components'

export type ChatMessageContextMenuProps = {
  onOpenClick?: () => void
}

export function ChatMessageContextMenu (props: ChatMessageContextMenuProps) {
  const { onOpenClick } = props

  return (
    <Menu>
      <li>
        <a onClick={() => onOpenClick?.()}>
          <ExternalLinkIcon size={16} />
          View details
        </a>
      </li>
    </Menu>
  )
}
